import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
//import { ApiService } from '../../shared/service/api.service';
import { ApplicantAPI } from '../shared/constant/url.constant';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ApplicantService {
  constructor( private readonly http: HttpClient) {}

  private getSessionValue(key: string): string | null {
    return sessionStorage.getItem(key);
  }

  private getHeaders(): HttpHeaders {
    const userId = this.getSessionValue('userId');
    const agencyId = this.getSessionValue('agencyId');
    const token = sessionStorage.getItem('applicationToken');
    let headers = new HttpHeaders();
    if(token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    if (userId) {
      headers = headers.set('user-id', userId);
    }
    if (agencyId) {
      headers = headers.set('agency-id', agencyId);
    }
    return headers;
  }

  private getParams(additional?: { [key: string]: string }): HttpParams {
    let params = new HttpParams();
    const userId = this.getSessionValue('userId');
    const agencyId = this.getSessionValue('agencyId');
    if (userId) {
      params = params.set('user-id', userId);
    }
    if (agencyId) {
      params = params.set('agency-id', agencyId);
    }
    return params;
  }

  uploadApplicantData(formData: any): Observable<any> {
    return this.http.post(
      ApplicantAPI.UploadBulkApplicants,
      formData,
      {
        headers: this.getHeaders(),
        params: this.getParams(),
        responseType: 'blob'
      }
    );
  }

  getApplicants(page: string, limit: string, keyword: string = ''): Observable<any> {
    return this.http.get(
      ApplicantAPI.GetApplicantListData,
      {
        params: new HttpParams().set('page', page).set('limit', limit).set('keyword', keyword),
        headers: this.getHeaders()
      }
    );
  }

  downloadDeterminationLetter(applicantId: number, applicationId: number): Observable<Blob> {
    const url = `${ApplicantAPI.DownloadLetter}${applicantId.toLocaleString()}/determination/${applicationId.toLocaleString()}`;
    return this.http.get(url, { headers: this.getHeaders(), responseType: 'blob' });
  }

  fetchApplicantDetails(applicantId: number): Observable<any> {
    const url = `${ApplicantAPI.FetchApplicantDetails}${applicantId}`;
    return this.http.get(url, { headers: this.getHeaders() });
  }

  fetchApplications(applicantId: string, page: string, limit: string): Observable<any> {
    const url = `${ApplicantAPI.FetchApplications}${applicantId}`;
    return this.http.get(
      url,
      {
        params: new HttpParams().set('page', page).set('limit', limit),
        headers: this.getHeaders()
      }
    );
  }

  terminateApplication(payload: any, applicationId: any): Observable<any> {
    const url = `${ApplicantAPI.TerminateApplication}${applicationId}/terminate`;
    return this.http.put(url, payload, { headers: this.getHeaders(), responseType: 'text' });
  }

  fetchTerminatedApplication(applicationId: string): Observable<any> {
    const url = `${ApplicantAPI.TerminateApplication}${applicationId}/terminate`;
    return this.http.get(url, { headers: this.getHeaders() });
  }

  addNewApplicant(payload: any): Observable<any> {
    const url = `${ApplicantAPI.AddNewApplicant}`;
    return this.http.post(
      url,
      payload,
      {
        headers: this.getHeaders(),
        params: this.getParams(),
        responseType: 'text'
      }
    );
  }
  fetchApplicantByPid(pid: string) {
    const url = `${ApplicantAPI.GetApplicantDetail}`;
    return this.http.get(url, { headers: this.getHeaders(), params: new HttpParams().set('PID', pid) });
  }
  downloadRecertificationLetter(applicationId: number): Observable<Blob> {
    const url = `${ApplicantAPI.DownloadLetter}${applicationId}/recertification-letter`;
    return this.http.get(url, { headers: this.getHeaders(), responseType: 'blob' });
  }
  checkForRenewalParentApplication(applicationId: string): Observable<any> {
    const url = `${ApplicantAPI.CheckRenewalParentApplication}${applicationId}/check-renewal-application`;
    return this.http.get(url, { headers: this.getHeaders() });
  }
}